// extracted by mini-css-extract-plugin
module.exports = {"positive":"ChangeIndicator_positive__346b-","negative":"ChangeIndicator_negative__3uyU8"};